/**
 * One spelling for a GUID, for use as a key: GUIDs are case-insensitive, and the API answers in
 * lower case, but an id pasted into a URL may arrive in upper case and is still the same record.
 */
export const normalizeGuid = (guid: string): string => guid.toLowerCase();

/**
 * Whether two GUID strings name the same id, whatever their case (PR 369 review 4).
 */
export const isSameGuid = (a: string, b: string): boolean =>
    normalizeGuid(a) === normalizeGuid(b);
